import React from 'react';

import Profile from '../components/Profile';

const ProfileContainer = () => <Profile names={['profile']} />;

export default ProfileContainer;
